import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import interact from 'interactjs';

class LoungerGenerator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      matrixModalOpen: false,
      matrixMatricula: '',
    };

    this.currentRotatingElement = null;
    this.initialMouseY = null;
    this.rotationStart = null;
  }

  componentDidMount() {
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.stopRotating);

    interact('.lounger-row')
      .draggable({
        listeners: {
          move(event) {
            const target = event.target;
            const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
            const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

            target.style.transform = `translate(${x}px, ${y}px) rotate(${target.dataset.rotation || 0}deg)`;
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
          }
        }
      });
  }

  componentWillUnmount() {
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.stopRotating);
  }

  startRotating = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.currentRotatingElement = e.currentTarget.closest('.lounger-row');
    this.initialMouseY = e.clientY;
    this.rotationStart = parseFloat(this.currentRotatingElement.dataset.rotation || 0);
  };

  handleMouseMove = (e) => {
    if (!this.currentRotatingElement) return;

    const deltaY = this.initialMouseY - e.clientY;
    const newRotation = this.rotationStart + deltaY; // 1px = 1deg

    const x = parseFloat(this.currentRotatingElement.getAttribute('data-x')) || 0;
    const y = parseFloat(this.currentRotatingElement.getAttribute('data-y')) || 0;

    this.currentRotatingElement.style.transform = `translate(${x}px, ${y}px) rotate(${newRotation}deg)`;
    this.currentRotatingElement.setAttribute('data-rotation', newRotation);
  };

  stopRotating = () => {
    this.currentRotatingElement = null;
    this.initialMouseY = null;
    this.rotationStart = null;
  };

  openMatrixDialog = (matricula) => {
    this.setState({ matrixModalOpen: true, matrixMatricula: matricula });
  };

  closeMatrixDialog = () => {
    this.setState({ matrixModalOpen: false });
  };

  render() {
    const { matrix, firstIndex } = this.props;
    const { matrixModalOpen, matrixMatricula } = this.state;

    if (!matrix || !matrix.Locker) return null;

    const matrixRender = [];
    const moduleMap = {};

    matrix.Locker.forEach(lock => {
      if (!moduleMap[lock.ModuleSN]) moduleMap[lock.ModuleSN] = [];
      moduleMap[lock.ModuleSN].push(lock);
    });

    Object.keys(moduleMap).forEach((moduleSN, rowIndex) => {
      const row = moduleMap[moduleSN];

      matrixRender.push(
        <div
          key={rowIndex}
          className="lounger-row"
          data-x="0"
          data-y="0"
          data-rotation="0"
          style={{
            display: 'flex',
            position: 'absolute',
            top: `${rowIndex * 80}px`,
            left: '0px',
            transform: 'translate(0px, 0px) rotate(0deg)',
            cursor: 'move',
            padding: '5px',
            background: '#fdfdfd',
            border: '1px dashed #ccc',
            borderRadius: '8px'
          }}
        >
          {row.map((lock, i) => (
            <div
              key={i}
              className="lounger"
              title={`Tumbona ${lock.Matricula}`}
              style={{
                width: '40px',
                height: '20px',
                background: '#c2a67a',
                margin: '4px',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '18px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                userSelect: 'none'
              }}
            >
              {lock.Matricula} - 🛏
            </div>
          ))}
          <div
            className="rotate-handle"
            onMouseDown={this.startRotating}
            title="Arrastra hacia arriba/abajo para rotar"
            style={{
              marginLeft: '10px',
              cursor: 'ns-resize',
              fontSize: '20px',
              alignSelf: 'center',
              userSelect: 'none'
            }}
          >
            🔄
          </div>
        </div>
      );
    });

    return (
      <div id="matrixContainer"
        style={{
          position: 'relative',
          width: '100%',
          height: '600px',
          backgroundImage: 'url("/images/pool.jpg")', // <-- your image path
          backgroundSize: 'cover', // or 'contain' or specific dimensions
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          overflow: 'hidden' // optional to hide overflowed rows
        }}>
        <div id="loungerMatrix">{matrixRender}</div>

        <Modal isOpen={matrixModalOpen} toggle={this.closeMatrixDialog} className="locker-modal-admin">
          <ModalHeader toggle={this.closeMatrixDialog}>
            <div className="text-center">
              <p>Información de tumbona {Number(matrixMatricula) + firstIndex}</p>
              <Button color="secondary" onClick={this.closeMatrixDialog}>
                Cerrar
              </Button>
            </div>
          </ModalHeader>
          <ModalBody>
            {/* Optional: Lounger details */}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.closeMatrixDialog}>
              Cerrar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
});

export default connect(mapStateToProps)(LoungerGenerator);
